/**
 * One heading hierarchy for every Organization Settings tab: a dark card
 * title, a line about the card, and labels for the groups, columns and
 * fields inside it, all in the same readable gray and weight.
 */

/** A settings card. */
export const SECTION = "rounded-lg border border-gray-200 bg-white p-5";
export const SECTION_TITLE = "block text-base font-bold text-neutral-900";
/** The line under a card title. */
export const SECTION_TEXT = "mt-1 text-sm text-gray-600";
/** A heading over a group of rows in a card. */
export const GROUP_LABEL = "mt-5 text-sm font-semibold text-gray-600";
/** Table column headings and form field labels. */
export const LABEL = "text-xs font-semibold text-gray-600";

/** "Enter a whole number from 1 to 14." when `text` is not one. */
export function wholeNumberError(text: string, min: number, max: number) {
  const value = Number(text);
  return /^\d+$/.test(text.trim()) && value >= min && value <= max
    ? undefined
    : `Enter a whole number from ${min} to ${max}.`;
}
